import type { ReactNode } from "react";
import { I18nextProvider } from "react-i18next";
import type { i18n as I18n } from "i18next";
import { QueryClientProvider } from "@tanstack/react-query";
import { ToastProvider } from "@agentsaas/ui";
import { ServicesProvider, type Services } from "./services";
import { SessionProvider } from "./session";
import { useT } from "./i18n";

function Toasts({ children }: { children: ReactNode }) {
  const { t } = useT();
  return <ToastProvider dismissLabel={t("shell.close")}>{children}</ToastProvider>;
}

/** 所有 Provider 的组合（测试里也用它包裹组件） */
export function Root({ services, i18n, children }: { services: Services; i18n: I18n; children: ReactNode }) {
  return (
    <I18nextProvider i18n={i18n}>
      <ServicesProvider services={services}>
        <QueryClientProvider client={services.queryClient}>
          <Toasts>
            <SessionProvider>{children}</SessionProvider>
          </Toasts>
        </QueryClientProvider>
      </ServicesProvider>
    </I18nextProvider>
  );
}
